module.exports = __webpack_public_path__ + "img/蝴蝶结.c8d18b5b.png";